import type { BCMediaInfo, LatestVideoResponse } from "@typings/Brightcove.d";
import { format, parseISO } from "date-fns";

export default function getProcessedBCResponse(
  data: BCMediaInfo[],
): LatestVideoResponse[] {
  return data.map((item) => {
    const {
      id,
      description,
      long_description,
      name,
      published_at,
      duration,
      thumbnail,
      tags,
      poster,
    } = item;

    const totalSeconds = duration / 1000;
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = Math.floor(totalSeconds % 60);
    const formattedTime = `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
    const date = new Date(published_at);
    const parsedDate = parseISO(published_at);
    const isPremium = tags?.some((tag) => tag.toLowerCase() === "premium");
    return {
      id,
      description,
      long_description,
      name,
      published_at: format(date, "MMM dd, yyyy"),
      topStoryDate: format(parsedDate, "EEEE, MMMM dd, yyyy"),
      duration: duration,
      formattedTime: formattedTime,
      nowPlaying: false,
      thumbnail,
      webinar_time: format(parsedDate, "h:mm a"),
      tags,
      isPremium,
      poster,
    };
  });
}
